import { useEffect } from "react";

const Redireccion = () => {
  useEffect(() => {
    window.location.href = "https://www.appsheet.com/start/6bc54bd8-2ee0-44e8-a1c6-f7589f424163?platform=desktop#vss=H4sIAAAAAAAAA6WOsQ6CMBRF_-XOHZ26GgdjdNG4WIZCH0kjtIQWlTT9dx-IcSaO9-ad827Cw9LzHHV1h7ylXzrQCImkcBk7UpAKW-9i7xsFoXDS7afs-oFKvVHIyIX44pECZFpF87k15KKtLfVTmkhesHAQM8XFwiCLf8YKtEPUZUPzWv6XMwtrXw2BzJW9q3027N3u1Wlnjt6wsdZNoPwGOBZQG2ABAAA=&view=prueba4&appName=prueba4-333722804";
  }, []);

  return <p>Redirigiendo...</p>;
};

export default Redireccion;
